import { render, staticRenderFns } from "./AnnouncementItem.vue?vue&type=template&id=2b344337&scoped=true"
import script from "./AnnouncementItem.vue?vue&type=script&lang=js"
export * from "./AnnouncementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b344337",
  null
  
)

export default component.exports